import { render } from "./ArtigoView.vue?vue&type=template&id=1339f2df&scoped=true"
import script from "./ArtigoView.vue?vue&type=script&lang=js"
export * from "./ArtigoView.vue?vue&type=script&lang=js"

import "./ArtigoView.vue?vue&type=style&index=0&id=1339f2df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1339f2df"]])

export default __exports__